import getInstanceAxios from "../Request";

const baseDomain = process.env.REACT_APP_BOOKING_DOMAIN;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
